<template>
  <div id="app">
    <page-loader :show="loading" :quote-loader="showQuoteLoader">
      <div class="row" v-if="showQuoteLoader">
        <div class="col-xs-12">
          <h4 class="text-center">Getting your quote now</h4>
          <uiv-carousel ref="carousel" :indicators="false" :controls="false" :interval="interval">
            <uiv-slide v-for="(slide, index) in slides" :key="index">
              <p class="text-center center-block _margin-top-0 _margin-bottom-30"
                style="max-width: 700px; font-size: 18px;">
                {{ slide.title }}
              </p>
            </uiv-slide>
          </uiv-carousel>
        </div>

        <div class="col-xs-12 _margin-bottom-30">
          <img v-if="quote_journey_session.evOnly || quote_journey_session.evCompare" class="center-block"
            style="max-width: 300px;" src="../assets/results-page/ev.png" />
          <img v-if="quote_journey_session.ashp" class="center-block" style="max-width: 300px;"
            src="../assets/results-page/ashp.png" />
          <img v-if="quote_journey_session.solar" class="center-block" style="max-width: 300px;"
            src="../assets/results-page/solar.png" />
        </div>
      </div>
    </page-loader>

    <navigation-bar></navigation-bar>
    <div class="main">
      <router-view></router-view>
    </div>
    <page-footer />
  </div>
</template>

<script>
import PageFooter from '@/components/page-footer/PageFooter';
import NavigationBar from '@/components/navigation-bar/NavigationBar';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'App',
  data () {
    return {
      interval: 4000
    };
  },
  mounted () {
    this.$store.dispatch('session/initialiseSession');
    this.$store.dispatch('storage/initialiseState');
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      session: ({ session }) => session,
      loading: ({ page_loader }) => page_loader.show,
      showQuoteLoader: ({ page_loader }) => page_loader.showQuoteLoader,
      quote_journey_session: ({ session }) => session.quote_journey_session
    }),
    ...mapGetters({
      quoteType: 'quote/quoteType'
    }),
    slides () {
      const heatingFuel = this.session.quote.heatFuel;
      let hasCarbon = '';

      if (this.quote_journey_session.evCompare) {
        hasCarbon = ' and Carbon impact';
      }

      if (this.quote_journey_session.ashp) {
        hasCarbon = heatingFuel != 2 ? ' and Carbon impact' : '';
      }

      return [
        { title: 'Looking at available tariffs' },
        { title: 'Crunching your energy consumption' },
        { title: 'Determining best tariff for you' },
        { title: 'Calculating Savings' + hasCarbon },
        { title: 'Finishing off final number crunching' }
      ];
    }
  },
  components: {
    NavigationBar,
    PageFooter
  }
};
</script>

<style lang="scss" src="../scss/main.scss"></style>
